import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import Table from "./UnitDetailTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faPen,
  faPlus,
  faTimes,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";

import { clientAccess, getUserType } from "../../utils/index";
import axios from "axios";
import apiUrl from "../../apiUrlConstant";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import { Redirect, withRouter, Link } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { floorOptions } from "../../constants";

import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class UnitDetailMaster extends React.Component {
  state = {
    url: `${apiUrl.apiUrl.url}/unit-detail/create`,
    id: undefined,
    assetNameValues: [],
    subAssetNameValues: [],
    LandlordGroups: [],
    popupContent: "",
    messsagePopup: false,
    delete: false,
    clientList: [],
    tower: [],
    unitStatus: [
      "Vacant",
      "Under Discussion (Prospect)",
      "Under Fit out",
      "Operational",
      "Owner Occupied",
    ],
    unitNumber: "",
    showPopupFloor: false,
    redirect: false,
    isSearchable: true,
    isClearable: true,
    unitTypes: [],
    floorImage: "",
    cropperRef: React.createRef(),
    initialValues: {
      groupId: "",
      unitId: "",
      groupName: "",
      clientId: "",
      clientName: "",
      assetName: "",
      subAssetName: "",
      tower: "",
      floor: "",
      unitType: "",
      unitTypeId: "",
      usableArea: "",
      grossLeasableArea: "",
      unitNumber: "",
      carpetArea: "",
      loadingPercent: "",
      efficiencyPercent: "",
      unitStatus: "",
      carpetAreaSqMt: "",
      usableAreaSqMt: "",
      grossLeasableAreaSqMt: "",
      compliance_count: "",
      compliance_percent: "",
      assetCompliance: [],
      availability: "",
      unitOwnership: "",
      buyerName: "",
      soldName: "",
      soldAmount: "",
      isCoWorking: "",
      efficiencyOnUsableArea: "",
      totalSeatUsable: "",
      efficiencyOnBillableArea: "",
      totalSeatBillable: "",
      parking: "no",
      fourWheelerParkingDetail: [],
      twoWheelerParkingDetail: [],
      otherWheelerParkingDetail: [],
    },
    totalFourWheelerParking: 0,
    totalTwoWheelerParking: 0,
    totalOtherParking: 0,
  };
  componentDidMount() {
    // console.log(`${apiUrl.apiUrl.url}`, "api");
    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/unit-detail/get-unit-types`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          unitTypes: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/asset/fetch-all-assets`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //let assetFromApi = Object.keys(data);

        this.setState({
          assetNameValues: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  changeAsset = (e) => {
    let assetId = e.target.value;
    //fetch(`${apiUrl.apiUrl.url}/sub-assets/asset-sub-assets/` + assetId,{headers})
    fetch(`${apiUrl.apiUrl.url}/asset/asset-sub-assets?id=` + assetId, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //let assetFromApi = Object.keys(data);

        this.setState({
          subAssetNameValues: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeSubAsset = (e) => {
    let subAssetId = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/asset/sub-asset-towers?id=` + subAssetId, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          tower: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  constructor(props) {
    super(props);
  }

  changeFloor = (newValue, values) => {
    this.state.initialValues.floor = newValue.value;
    values.floor = newValue.value;
    this.setState({});
    console.groupEnd();

    console.log(this.state.initialValues,"this.state.initialValues")
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/unit-detail/fetch-floor-details?assetId=${this.state.initialValues.assetName}&towerId=${this.state.initialValues.tower}&floor=${newValue.value}`,
    }).then(function (response) {
      console.log(response, "response", response.data.image)
      if(typeof response.data.image != "undefined" && response.data.image.length > 0) {
        self.setState({ floorImage: `${apiUrl.apiUrl.url}/${response.data.image}` });
      }else{
        self.setState({ floorImage: null });
      }

      console.log(self.state.floorImage, "floorImage")
      
    });

  };

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/unit-detail/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        self.setState({
          messsagePopup: true,
          popupContent: "Sorry you cannot delete this item",
        });
      } else {
        self.setState({
          delete: true,
        });
      }
    });
  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.state.unitStatus = [
          "Vacant",
          "Under Discussion (Prospect)",
          "Under Fit out",
          "Operational",
          "Owner Occupied",
        ];
        this.setState({
          url: `${apiUrl.apiUrl.url}/unit-detail/create`,
          cropperRef: React.createRef(),
          floorImage: "",
          initialValues: {
            groupId: "",
            unitId: "",
            groupName: "",
            clientId: "",
            clientName: "",
            assetName: "",
            subAssetName: "",
            tower: "",
            floor: "",
            unitType: "",
            usableArea: "",
            grossLeasableArea: "",
            unitNumber: "",
            carpetArea: "",
            loadingPercent: "",
            efficiencyPercent: "",
            unitStatus: "",
            carpetAreaSqMt: "",
            usableAreaSqMt: "",
            grossLeasableAreaSqMt: "",
            assetCompliance: [],
            availability: "",
            unitOwnership: "",
            buyerName: "",
            soldName: "",
            soldAmount: "",
            isCoWorking: "",
            efficiencyOnUsableArea: "",
            totalSeatUsable: "",
            efficiencyOnBillableArea: "",
            totalSeatBillable: "",
            parking: "no",
            fourWheelerParkingDetail: [],
            twoWheelerParkingDetail: [],
            otherWheelerParkingDetail: [],
          },
        });
      } else {

        let athis = this;
        axios({
          method: "get",
          url: `${apiUrl.apiUrl.url}/unit-detail/fetch-unit?id=${this.props.match.params.id}`
        }).then(function(response) {

          let data = response.data;

          athis.state.unitStatus = [
            "Vacant",
            "Under Discussion (Prospect)",
            "Under Fit out",
            "Operational",
            "Owner Occupied",
          ];
          if (data.data.unitStatus == "Leased") {
            athis.state.unitStatus.push("Leased");
          }
          data.data.carpetAreaSqMt = (data.data.carpetArea / 10.764).toFixed(
            2
          );
          data.data.usableAreaSqMt = (data.data.usableArea / 10.764).toFixed(
            2
          );
          data.data.grossLeasableAreaSqMt = (
            data.data.grossLeasableArea / 10.764
          ).toFixed(2);
          athis.setState({
            url: `${apiUrl.apiUrl.url}/unit-detail/update?id=${athis.props.match.params.id}`,
            initialValues: data.data,
            subAssetNameValues: data.subAssets,
            tower: data.towers,
            LandlordGroups: data.LandlordGroups,
            clientList: data.clientList,
            totalFourWheelerParking:
              data.data.fourWheelerParkingDetail.length,
            totalTwoWheelerParking: data.data.twoWheelerParkingDetail.length,
            totalOtherParking: data.data.otherWheelerParkingDetail.length
          });

          if(data.data.floorImage.length > 0 ) {
            athis.setState({ floorImage: `${apiUrl.apiUrl.url}/${data.data.floorImage}` });
          }else{
            athis.setState({ floorImage: null });
          }

          athis.complianceList(data.data.clientId, data.data.unitId);


        });


        // fetch(
        //   `${apiUrl.apiUrl.url}/unit-detail/fetch-unit?id=${this.props.match.params.id}`
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     this.state.unitStatus = [
        //       "Vacant",
        //       "Under Discussion (Prospect)",
        //       "Under Fit out",
        //       "Operational",
        //       "Owner Occupied",
        //     ];
        //     if (data.data.unitStatus == "Leased") {
        //       this.state.unitStatus.push("Leased");
        //     }
        //     data.data.carpetAreaSqMt = (data.data.carpetArea / 10.764).toFixed(
        //       2
        //     );
        //     data.data.usableAreaSqMt = (data.data.usableArea / 10.764).toFixed(
        //       2
        //     );
        //     data.data.grossLeasableAreaSqMt = (
        //       data.data.grossLeasableArea / 10.764
        //     ).toFixed(2);
        //     this.setState({
        //       url: `${apiUrl.apiUrl.url}/unit-detail/update?id=${this.props.match.params.id}`,
        //       initialValues: data.data,
        //       subAssetNameValues: data.subAssets,
        //       tower: data.towers,
        //       LandlordGroups: data.LandlordGroups,
        //       clientList: data.clientList,
        //       totalFourWheelerParking:
        //         data.data.fourWheelerParkingDetail.length,
        //       totalTwoWheelerParking: data.data.twoWheelerParkingDetail.length,
        //       totalOtherParking: data.data.otherWheelerParkingDetail.length
        //     });

        //     if(data.data.floorImage.length > 0 ) {
        //       this.setState({ floorImage: `${apiUrl.apiUrl.url}/${data.data.floorImage}` });
        //     }else{
        //       this.setState({ floorImage: null });
        //     }

        //     this.complianceList(data.data.clientId, data.data.unitId);

        //     console.log(this.state.initialValues, "iv");
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      }
    }
  }

  calculateCarpetSqMt(e, values) {
    let sqMeter = (e.target.value / 10.764).toFixed(4);
    values.carpetAreaSqMt = sqMeter;
    this.setState({});
  }

  calculateUsableSqMt(e, values) {
    console.log(values);
    let sqMeter = (e.target.value / 10.764).toFixed(4);
    values.usableAreaSqMt = sqMeter;
    if (
      !isNaN(e.target.value) &&
      !isNaN(values.grossLeasableArea) &&
      values.grossLeasableArea !== 0 &&
      values.grossLeasableArea !== ""
    ) {
      values.efficiencyPercent = (
        (e.target.value / values.grossLeasableArea) *
        100
      ).toFixed(2);
      values.loadingPercent = (
        values.grossLeasableArea / e.target.value
      ).toFixed(2);
    }
    this.setState({});
  }

  calculateGrossSqMt(e, values) {
    let sqMeter = (e.target.value / 10.764).toFixed(4);
    values.grossLeasableAreaSqMt = sqMeter;
    if (
      !isNaN(values.usableArea) &&
      !isNaN(e.target.value) &&
      e.target.value !== 0
    ) {
      values.efficiencyPercent = (
        (values.usableArea / e.target.value) *
        100
      ).toFixed(2);
      values.loadingPercent = (e.target.value / values.usableArea).toFixed(2);
    }
    this.setState({});
  }

  calculateUsableSqFt(e, values) {
    let sqFt = (e.target.value * 10.764).toFixed(2);
    values.usableArea = sqFt;
    if (
      !isNaN(values.usableArea) &&
      !isNaN(values.grossLeasableArea) &&
      values.grossLeasableArea !== 0 &&
      values.grossLeasableArea !== ""
    ) {
      values.efficiencyPercent = (
        (values.usableArea / values.grossLeasableArea) *
        100
      ).toFixed(2);
      values.loadingPercent = (
        values.grossLeasableArea / values.usableArea
      ).toFixed(2);
    }
    this.setState({});
  }

  calculateCarpetSqFt(e, values) {
    let sqFt = (e.target.value * 10.764).toFixed(2);
    values.carpetArea = sqFt;
    this.setState({});
  }

  calculateGrossSqFt(e, values) {
    let sqFt = (e.target.value * 10.764).toFixed(2);
    values.grossLeasableArea = sqFt;
    if (
      !isNaN(values.usableArea) &&
      !isNaN(values.grossLeasableArea) &&
      values.grossLeasableArea !== 0
    ) {
      values.efficiencyPercent = (
        (values.usableArea / values.grossLeasableArea) *
        100
      ).toFixed(2);
      values.loadingPercent = (
        values.grossLeasableArea / values.usableArea
      ).toFixed(2);
    }
    this.setState({});
  }

  handleChangeUnitType = (newValue) => {
    console.log("unit change");
    this.state.initialValues.unitTypeId = newValue.value;
    this.state.initialValues.unitType = newValue.label;
    this.setState({});
  };

  handleChangeLandlordGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionMeta", actionMeta);

    if (actionMeta == "change_client_group") {
      this.state.initialValues.groupId = newValue.value;
      this.state.initialValues.groupName = newValue.label;

      fetch(`${apiUrl.apiUrl.url}/client/client-list?groupId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            clientList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    } else {
      this.state.initialValues.clientId = newValue.value;
      this.state.initialValues.clientName = newValue.label;

      this.complianceList(newValue.value, this.state.initialValues.unitId);
    }
    this.setState({});
    //this.state.initialValues.groupName = newValue.label;

    this.groupId = newValue;
    console.log(this.groupId, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  complianceList = (clientId, id) => {
    var ths = this;
    fetch(
      `${apiUrl.apiUrl.url}/compliance/get-list-asset?type=unit&client_id=${clientId}&id=${id}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "compliance data");
        // this.setState({
        //   assetCompliance: data.data,
        // });
        ths.state.initialValues.assetCompliance = data.data;
        ths.state.compliance_count = data.count;
        ths.state.compliance_percent = data.percent_count;
        ths.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Handle the image file change
  onImageChange = (e, type) => {
    e.preventDefault();
    const files = e.target.files;
    if (files && files.length > 0) {
      const reader = new FileReader();
      reader.onload = () => {
        this.setState({ floorImage: reader.result, showPopupFloor: true });
      };
      reader.readAsDataURL(files[0]);
    }
  };

  // Handle cropping the image
  getCroppedImage = (e, type) => {
    e.preventDefault();
    let cropper, croppedCanvas, croppedImageUrl;
    cropper = this.state.cropperRef.current.cropper;

    croppedCanvas = cropper.getCroppedCanvas();
    if (croppedCanvas) {
      croppedImageUrl = croppedCanvas.toDataURL();
      console.log("Cropped Image URL:", croppedImageUrl);

      this.setState({ floorImage: croppedImageUrl, showPopupFloor: false });
      // You can process or upload the cropped image here
    }
  };

  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/unit-detail/delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: "Something Went Wrong",
        });
      } else {
        ths.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      floorImage: "",
      initialValues: {
        groupId: "",
        unitId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        assetName: "",
        subAssetName: "",
        tower: "",
        floor: "",
        unitType: "",
        usableArea: "",
        grossLeasableArea: "",
        unitNumber: "",
        carpetArea: "",
        loadingPercent: "",
        efficiencyPercent: "",
        unitStatus: "",
        carpetAreaSqMt: "",
        usableAreaSqMt: "",
        grossLeasableAreaSqMt: "",
        assetCompliance: [],
        availability: "",
        unitOwnership: "",
        buyerName: "",
        soldName: "",
        soldAmount: "",
        isCoWorking: "",
        efficiencyOnUsableArea: "",
        totalSeatUsable: "",
        efficiencyOnBillableArea: "",
        totalSeatBillable: "",
        parking: "no",
        fourWheelerParkingDetail: [],
        twoWheelerParkingDetail: [],
        otherWheelerParkingDetail: [],
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      floorImage: "",
      initialValues: {
        groupId: "",
        unitId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        assetName: "",
        subAssetName: "",
        tower: "",
        floor: "",
        unitType: "",
        usableArea: "",
        grossLeasableArea: "",
        unitNumber: "",
        carpetArea: "",
        loadingPercent: "",
        efficiencyPercent: "",
        unitStatus: "",
        carpetAreaSqMt: "",
        usableAreaSqMt: "",
        grossLeasableAreaSqMt: "",
        assetCompliance: [],
        availability: "",
        unitOwnership: "",
        buyerName: "",
        soldName: "",
        soldAmount: "",
        isCoWorking: "",
        efficiencyOnUsableArea: "",
        totalSeatUsable: "",
        efficiencyOnBillableArea: "",
        totalSeatBillable: "",
        parking: "no",
        fourWheelerParkingDetail: [],
        twoWheelerParkingDetail: [],
        otherWheelerParkingDetail: [],
      },
    });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/unit-detail" />;
    }
    return <div className="parentContainer">{this.renderForm()}</div>;
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li>
                <FontAwesomeIcon icon={faChevronRight} />
              </li>
              <li>
                <Link to="/masters/unit-directory">Unit Directory</Link>
              </li>
              <li>
                <FontAwesomeIcon icon={faChevronRight} />
              </li>
              <li>
                <Link to="#">Unit Detail</Link>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            //alert(JSON.stringify(values, null, 2)); return true;

            values.unitType = this.state.initialValues.unitType;
            values.floorImage = this.state.floorImage;

            var self = this;
            axios({
              method: "post",
              url: this.state.url,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                actions.setSubmitting(false);

                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: "Data Saved Successfully!",
                });
              }
            });

            //}, 1000);
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Group <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="clientGroup"
                              onChange={(e) => {
                                this.handleChangeLandlordGroup(
                                  e,
                                  "change_client_group"
                                );
                              }}
                              value={{
                                label: this.state.initialValues.groupName,
                                value: this.state.initialValues.groupId,
                              }}
                              options={this.state.LandlordGroups.map(
                                (item) => ({
                                  label: item.group_name,
                                  value: item.id,
                                })
                              )}
                            />
                            <ErrorMessage
                              name="clientGroup"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      )}

                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Name <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="clientName"
                              onChange={(e) => {
                                this.handleChangeLandlordGroup(
                                  e,
                                  "change_client_name"
                                );
                              }}
                              value={{
                                label: this.state.initialValues.clientName,
                                value: this.state.initialValues.clientId,
                              }}
                              options={this.state.clientList.map((item) => ({
                                label: item.client_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage
                              name="clientName"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      )}

                      <div className="newGridSectionInner">
                        <label>
                          Asset Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="assetName"
                            onChange={(e) => {
                              this.state.initialValues.assetName = e.target.value;
                              this.changeAsset(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.assetNameValues.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.asset_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="assetName"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Sub Asset Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="subAssetName"
                            onChange={(e) => {
                              this.changeSubAsset(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.subAssetNameValues.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.sub_asset_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="subAssetName"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Tower <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="tower"
                            onChange={(e) => {
                              const selectedOption =
                                e.currentTarget[e.currentTarget.selectedIndex];
                              const isCoWorking =
                                selectedOption.getAttribute("coworking");
                              this.state.initialValues.isCoWorking =
                                isCoWorking;
                              console.log(isCoWorking, "co working value");
                              this.state.initialValues.tower = e.target.value;
                              this.setState({});
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.tower.map((obj) => (
                              <option
                                key={obj.id}
                                value={obj.id}
                                coworking={obj.is_coworking}
                              >
                                {obj.tower_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="tower"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Floor <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            isSearchable={this.state.isSearchable}
                            name="floor"
                            value={{
                              label: this.state.initialValues.floor,
                              value: this.state.initialValues.floor,
                            }}
                            onChange={(e) => {
                              this.changeFloor(e, values);
                            }}
                            options={floorOptions.map((item) => ({
                              label: item,
                              value: item,
                            }))}
                          />
                          <ErrorMessage
                            name="floor"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Unit Type <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <CreatableSelect
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="unitType"
                            onChange={(e) => {
                              this.handleChangeUnitType(e);
                            }}
                            value={{
                              label: this.state.initialValues.unitType,
                              value: this.state.initialValues.unitTypeId,
                            }}
                            options={this.state.unitTypes.map((item) => ({
                              label: item.unit_type,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="unitType"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Unit Status <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="unitStatus"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.unitStatus.map((unitStatus) => (
                              <option key={unitStatus} value={unitStatus}>
                                {unitStatus}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="unitStatus"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Unit Number <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="unitNumber"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                          <ErrorMessage
                            name="unitNumber"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner usableArea">
                        <label>
                          Usable Area <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <div className="row">
                            <div className="col-sm-6">
                              <Field
                                type="number"
                                name="usableArea"
                                placeholder="sq.ft"
                                onBlur={(e) => {
                                  this.calculateUsableSqMt(e, values);
                                }}
                              />
                            </div>
                            <div className="col-sm-6">
                              <Field
                                type="number"
                                name="usableAreaSqMt"
                                onBlur={(e) => {
                                  this.calculateUsableSqFt(e, values);
                                }}
                                placeholder="sq.mt"
                              />
                            </div>
                          </div>
                          {/* <ErrorMessage
                          name="usableArea"
                          component="div"
                          className="text-red"
                          /> */}
                        </div>
                      </div>

                      <div className="newGridSectionInner usableArea">
                        <label>
                          Carpet Area <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <div className="row">
                            <div className="col-sm-6">
                              <Field
                                type="number"
                                name="carpetArea"
                                placeholder="sq.ft"
                                onChange={(e) => {
                                  handleChange(e, values);
                                }}
                                onBlur={(e) => {
                                  this.calculateCarpetSqMt(e, values);
                                }}
                              />
                            </div>
                            <div className="col-sm-6">
                              <Field
                                type="number"
                                name="carpetAreaSqMt"
                                placeholder="sq.mt"
                                onBlur={(e) => {
                                  this.calculateCarpetSqFt(e, values);
                                }}
                              />
                            </div>
                          </div>
                          {/* <ErrorMessage
    name="carpetArea"
    component="div"
    className="text-red"
    /> */}
                        </div>
                      </div>

                      <div className="newGridSectionInner usableArea">
                        <label>
                          Gross Leasable Area <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <div className="row">
                            <div className="col-sm-6">
                              <Field
                                type="number"
                                name="grossLeasableArea"
                                onBlur={(e) => {
                                  this.calculateGrossSqMt(e, values);
                                }}
                                placeholder="sq.ft"
                              />
                            </div>
                            <div className="col-sm-6">
                              <Field
                                type="number"
                                name="grossLeasableAreaSqMt"
                                onBlur={(e) => {
                                  this.calculateGrossSqFt(e, values);
                                }}
                                placeholder="sq.mt"
                              />
                            </div>
                          </div>
                          {/* <ErrorMessage
    name="grossLeasableArea"
    component="div"
    className="text-red"
    /> */}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Loading <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="number" name="loadingPercent" />
                          <ErrorMessage
                            name="loadingPercent"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Efficiency %<span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="number" name="efficiencyPercent" />
                          <ErrorMessage
                            name="efficiencyPercent"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {getUserType() != "occupier" && (
                        <>
                          <div className="newGridSectionInner">
                            <label>
                              Unit Ownership <span className="astrik"></span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="unitOwnership"
                                onChange={(e) => {
                                  this.state.initialValues.unitOwnership =
                                    e.target.value;
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                <option value="sold" label="Sold" />
                                <option value="owned" label="Owned" />
                              </Field>
                              <ErrorMessage
                                name="unitOwnership"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>
                            Current Availability <span className="astrik"></span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="unitAvailability"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                <option value="yes" label="Yes" />
                                <option value="no" label="No" />
                              </Field>
                              <ErrorMessage
                                name="availability"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </>
                      )}
                      {this.state.initialValues.unitOwnership === "sold" && (
                        <>
                          <div className="newGridSectionInner">
                            <label>
                              Buyer Name <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field type="text" name="buyerName" />
                              <ErrorMessage
                                name="buyerName"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>
                              Sold Date <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field type="date" name="soldDate" />
                              <ErrorMessage
                                name="soldDate"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>
                              Sold Amount <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field type="number" name="soldAmount" />
                              <ErrorMessage
                                name="soldAmount"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </>
                      )}
                      <div className="newGridSectionInner">
                        <label>Vacant Since</label>
                        <div className="position-relative">
                          <Field type="date" name="vacantSince" />
                        </div>
                      </div>
                      {this.state.initialValues.isCoWorking == "yes" && (
                        <>
                          <div className="newGridSectionInner">
                            <label>Efficiency On Usable Area</label>
                            <div className="position-relative">
                              <Field
                                type="number"
                                name="efficiencyOnUsableArea"
                              />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>Total no of Seats Usable</label>
                            <div className="position-relative">
                              <Field type="number" name="totalSeatUsable" />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>Efficiency on Billable Area(Per Seat)</label>
                            <div className="position-relative">
                              <Field
                                type="number"
                                name="efficiencyOnBillableArea"
                              />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>Total no of Seats Billable</label>
                            <div className="position-relative">
                              <Field type="number" name="totalSeatBillable" />
                            </div>
                          </div>
                        </>
                      )}
                      <div className="gridColOneByThree">
                        <div className="row m-0">
                          <div className="col-6 ps-0">
                            <div className="newGridSectionInner">
                              <label>
                                Parking<span className="astrik"></span>
                              </label>
                              <div className="position-relaive">
                                <Field
                                  as="select"
                                  name="parking"
                                  onChange={(e) => {
                                    this.state.initialValues.parking =
                                      e.target.value;
                                    this.setState({});
                                    handleChange(e);
                                  }}
                                >
                                  <option value="no" label="No" defaultValue />
                                  <option value="yes" label="Yes" />
                                </Field>
                                <ErrorMessage
                                  name="parking"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-6 pe-0"></div>
                        </div>
                      </div>
                      {this.state.initialValues.parking == "yes" && (
                        <>
                          <div className="newGridSectionInner">
                            <label className="">4 wheeler parking</label>
                            <div className="position-relative">
                              <Field
                                type="number"
                                name="totalFourWheelerParking"
                                onChange={(e) => {
                                  handleChange(e);
                                  this.setState(
                                    {
                                      totalFourWheelerParking: parseInt(
                                        e.target.value
                                      ),
                                    },
                                    () => {
                                      //console.log(this.state.totalFourWheelerParking); // Logs the updated value in the callback
                                    }
                                  );

                                  this.setState({});
                                }}
                              />
                            </div>
                          </div>

                          <div className="gridColOneByThree">
                            <div
                              className="newGridSectionInner"
                              style={{ gridTemplateColumns: "159px 1fr" }}
                            >
                              <div></div>
                              <div className="parkingGridSections">
                                {Array.from(
                                  {
                                    length: this.state.totalFourWheelerParking,
                                  },
                                  (_, index) => (
                                    <div key={index}>
                                      <Field
                                        type="text"
                                        name={`fourWheelerParkingDetail[${index}]`}
                                        value={
                                          values.fourWheelerParkingDetail[
                                            index
                                          ] ?? ""
                                        }
                                        onChange={handleChange}
                                      />
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label className="">2 wheeler parking</label>
                            <div className="position-relative">
                              <Field
                                type="number"
                                name="totalTwoWheelerParking"
                                onChange={(e) => {
                                  handleChange(e);
                                  this.setState(
                                    {
                                      totalTwoWheelerParking: parseInt(
                                        e.target.value
                                      ),
                                    },
                                    () => {
                                      //console.log(this.state.totalTwoWheelerParking); // Logs the updated value in the callback
                                    }
                                  );

                                  this.setState({});
                                }}
                              />
                            </div>
                          </div>

                          <div className="gridColOneByThree">
                            <div
                              className="newGridSectionInner"
                              style={{ gridTemplateColumns: "159px 1fr" }}
                            >
                              <div></div>
                              <div className="parkingGridSections">
                                {Array.from(
                                  { length: this.state.totalTwoWheelerParking },
                                  (_, index) => (
                                    <div key={index}>
                                      <Field
                                        type="text"
                                        name={`twoWheelerParkingDetail[${index}]`}
                                        value={
                                          values.twoWheelerParkingDetail[
                                            index
                                          ] ?? ""
                                        }
                                        onChange={handleChange}
                                      />
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label className="">Other parking</label>
                            <div className="position-relative">
                              <Field
                                type="number"
                                name="totalOtherParking"
                                onChange={(e) => {
                                  handleChange(e);
                                  this.setState(
                                    {
                                      totalOtherParking: parseInt(
                                        e.target.value
                                      ),
                                    },
                                    () => {
                                      //console.log(this.state.totalOtherParking); // Logs the updated value in the callback
                                    }
                                  );

                                  this.setState({});
                                }}
                              />
                            </div>
                          </div>

                          <div className="gridColOneByThree">
                            <div
                              className="newGridSectionInner"
                              style={{ gridTemplateColumns: "159px 1fr" }}
                            >
                              <div></div>
                              <div className="parkingGridSections">
                                {Array.from(
                                  { length: this.state.totalOtherParking },
                                  (_, index) => (
                                    <div key={index}>
                                      <Field
                                        type="text"
                                        name={`otherWheelerParkingDetail[${index}]`}
                                        value={
                                          values.otherWheelerParkingDetail[
                                            index
                                          ] ?? ""
                                        }
                                        onChange={handleChange}
                                      />
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      <div>
                        <b>Floor Image </b>
                        {this.state.floorImage ? (
                          <div className="position-relative addImagePlaceholder addImagePlaceholderWithDelete">
                            <img
                              src={this.state.floorImage}
                              className="img-fluid"
                            />
                            <spam className="deleteButton" onClick={(e)=> {
                                  e.preventDefault();
                                  this.setState({ floorImage: null });
                                }}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1em"
                                height="1em"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="currentColor"
                                  d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"
                                />
                              </svg>
                            </spam>
                          </div>
                        ) : (
                          <div className="position-relative addImagePlaceholder">
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                this.onImageChange(e, "floor");
                              }}
                            />
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="1em"
                              height="1em"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="currentColor"
                                d="M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z"
                              />
                            </svg>
                          </div>
                        )}

                        {this.state.floorImage && (
                          <>
                            {this.state.showPopupFloor === true ? (
                              <div className="fixedDiv">
                                <Cropper
                                  src={this.state.floorImage}
                                  style={{ height: 400, width: "100%" }}
                                  initialAspectRatio={1}
                                  aspectRatio={1}
                                  guides={false}
                                  viewMode={1}
                                  dragMode="move"
                                  ref={this.state.cropperRef}
                                />
                                {/* <button onClick={(e) => {}}>Crop Image</button> */}
                                <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-center">
                                  <button
                                    className="update_button"
                                    onClick={(e) => {
                                      console.log(e);
                                      this.setState({
                                        showPopupFloor: false,
                                      });
                                      this.getCroppedImage(e, "floor");
                                    }}
                                  >
                                    Crop Image
                                  </button>
                                </div>
                              </div>
                            ) : null}
                          </>
                        )}
                      </div>

                      {this.state.initialValues.assetCompliance.length > 0 && (
                        <>
                          <div className="newGridSectionInner">
                            <label className="gridColOneByThree">
                              Compliance Count: {this.state.compliance_count}
                            </label>
                          </div>
                          <div className="newGridSectionInner">
                            <label className="gridColOneByThree">
                              Compliance Complete Percent(%):
                              {this.state.compliance_percent}
                            </label>
                          </div>
                        </>
                      )}

                      {this.state.initialValues.assetCompliance.length > 0 && (
                        <div className="tableContainer leaseLandlord gridColOneByThree">
                          <table className="table tableSimple text-center">
                            <thead>
                              <tr>
                                <th>Compliance Name</th>
                                <th>Compliance Answer</th>
                              </tr>
                            </thead>
                            {this.state.initialValues.assetCompliance.map(
                              (obj, i) => (
                                <tr style={{ height: "25px" }}>
                                  <td>{obj.name}</td>
                                  {obj.compliance_datatype == "date" && (
                                    <td>
                                      <Field
                                        type="date"
                                        name={
                                          "assetCompliance[" + i + "].value"
                                        }
                                      />
                                    </td>
                                  )}
                                  {obj.compliance_datatype == "checkbox" && (
                                    <td>
                                      <Field
                                        type="checkbox"
                                        name={
                                          "assetCompliance[" + i + "].value"
                                        }
                                      />
                                    </td>
                                  )}
                                </tr>
                              )
                            )}
                          </table>
                        </div>
                      )}
                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button
                          type="submit"
                          className="update_button"
                          disabled={isSubmitting}
                        >
                          Update
                        </button>
                        <button
                          className="delete_button"
                          type="button"
                          onClick={(e) => {
                            this.checkDelete(e);
                          }}
                        >
                          Delete
                        </button>
                        <button
                          type="reset"
                          className="reset_button"
                          onClick={this.redirectAfterEdit}
                        >
                          <Link to="/masters/unit-detail">Reset</Link>
                        </button>
                      </div>
                    ) : (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button
                          type="submit"
                          className="add_button"
                          disabled={isSubmitting}
                        >
                          Add
                        </button>
                        <button
                          type="reset"
                          className="reset_button"
                          onClick={this.redirectAfterEdit}
                        >
                          Reset
                        </button>
                      </div>
                    )}
                  </div>
                </Form>
              </div>

              {/* <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="container">
                    <div className="row">
                      {clientAccess() && (
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Client Group <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <Select
                                  className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                  name="clientGroup"
                                  //onInputChange={this.handleChange}
                                  onChange={(e) => {
                                    this.handleChangeLandlordGroup(
                                      e,
                                      "change_client_group"
                                    );
                                  }}
                                  value={{
                                    label: this.state.initialValues.groupName,
                                    value: this.state.initialValues.groupId,
                                  }}
                                  options={this.state.LandlordGroups.map(
                                    (item) => ({
                                      label: item.group_name,
                                      value: item.id,
                                    })
                                  )}
                                />

                                <ErrorMessage
                                  name="clientGroup"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {clientAccess() && (
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Client Name <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <Select
                                  className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                  name="clientName"
                                  onChange={(e) => {
                                    this.handleChangeLandlordGroup(
                                      e,
                                      "change_client_name"
                                    );
                                  }}
                                  value={{
                                    label: this.state.initialValues.clientName,
                                    value: this.state.initialValues.clientId,
                                  }}
                                  options={this.state.clientList.map((item) => ({
                                    label: item.client_name,
                                    value: item.id,
                                  }))}
                                />
                                <ErrorMessage
                                  name="clientName"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Asset Name <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="assetName"
                                onChange={(e) => {
                                  this.changeAsset(e);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.assetNameValues.map((obj) => (
                                  <option key={obj.id} value={obj.id}>
                                    {obj.asset_name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="assetName"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Sub Asset Name
                              <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="subAssetName"
                                onChange={(e) => {
                                  this.changeSubAsset(e);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.subAssetNameValues.map((obj) => (
                                  <option key={obj.id} value={obj.id}>
                                    {obj.sub_asset_name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="subAssetName"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Tower <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="tower"
                                onChange={(e) => {
                                  const selectedOption = e.currentTarget[e.currentTarget.selectedIndex];
                                  const isCoWorking = selectedOption.getAttribute('coworking');
                                  this.state.initialValues.isCoWorking = isCoWorking;
                                  console.log(isCoWorking, "co working value")
                                  this.setState({});
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.tower.map((obj) => (
                                  <option key={obj.id} value={obj.id} coworking={obj.is_coworking} >
                                    {obj.tower_name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="tower"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Floor <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                isSearchable={this.state.isSearchable}
                                name="floor"
                                value={{
                                  label: this.state.initialValues.floor,
                                  value: this.state.initialValues.floor,
                                }}
                                onChange={(e) => {
                                  this.changeFloor(e, values);
                                }}
                                options={floorOptions.map((item) => ({
                                  label: item,
                                  value: item,
                                }))}
                              />
                              <ErrorMessage
                                name="floor"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Unit Type <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <CreatableSelect
                                name="unitType"
                                onChange={(e) => {
                                  this.handleChangeUnitType(e);
                                }}
                                value={{
                                  label: this.state.initialValues.unitType,
                                  value: this.state.initialValues.unitTypeId,
                                }}
                                options={this.state.unitTypes.map((item) => ({
                                  label: item.unit_type,
                                  value: item.id,
                                }))}
                              />

                              <Field
                              as="select"
                              name="unitType"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            >
                              <option value="" label="Select" defaultValue />
                              <option value="Anchor" label="Anchor" />
                              <option value="Mini Anchor" label="Mini Anchor" />
                              <option value="Vanilla" label="Vanilla" />
                              <option value="Kiosk" label="Kiosk" />
                              <option value="Office" label="Office" />
                            </Field>
                              <ErrorMessage
                                name="unitType"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Unit Status <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="unitStatus"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.unitStatus.map((unitStatus) => (
                                  <option key={unitStatus} value={unitStatus}>
                                    {unitStatus}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="unitStatus"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Unit Number <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                name="unitNumber"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              />
                              <ErrorMessage
                                name="unitNumber"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12 usableArea">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Usable Area <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <div className="row">
                                <div className="col-sm-6">
                                  <Field
                                    type="number"
                                    name="usableArea"
                                    placeholder="sq.ft"
                                    onBlur={(e) => {
                                      this.calculateUsableSqMt(e, values);
                                    }}
                                  />
                                </div>
                                <div className="col-sm-6">
                                  <Field
                                    type="number"
                                    name="usableAreaSqMt"
                                    onBlur={(e) => {
                                      this.calculateUsableSqFt(e, values);
                                    }}
                                    placeholder="sq.mt"
                                  />
                                </div>
                              </div>
                              <ErrorMessage
                              name="usableArea"
                              component="div"
                              className="text-red"
                            />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12 usableArea">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Carpet Area
                              <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <div className="row">
                                <div className="col-sm-6">
                                  <Field
                                    type="number"
                                    name="carpetArea"
                                    placeholder="sq.ft"
                                    onChange={(e) => {
                                      handleChange(e, values);
                                    }}
                                    onBlur={(e) => {
                                      this.calculateCarpetSqMt(e, values);
                                    }}
                                  />
                                </div>
                                <div className="col-sm-6">
                                  <Field
                                    type="number"
                                    name="carpetAreaSqMt"
                                    placeholder="sq.mt"
                                    onBlur={(e) => {
                                      this.calculateCarpetSqFt(e, values);
                                    }}
                                  />
                                </div>
                              </div>
                              <ErrorMessage
                              name="carpetArea"
                              component="div"
                              className="text-red"
                            />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12 usableArea">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Gross Leasable Area{" "}
                              <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <div className="row">
                                <div className="col-sm-6">
                                  <Field
                                    type="number"
                                    name="grossLeasableArea"
                                    onBlur={(e) => {
                                      this.calculateGrossSqMt(e, values);
                                    }}
                                    placeholder="sq.ft"
                                  />
                                </div>
                                <div className="col-sm-6">
                                  <Field
                                    type="number"
                                    name="grossLeasableAreaSqMt"
                                    onBlur={(e) => {
                                      this.calculateGrossSqFt(e, values);
                                    }}
                                    placeholder="sq.mt"
                                  />
                                </div>
                              </div>
                              <ErrorMessage
                              name="grossLeasableArea"
                              component="div"
                              className="text-red"
                            />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Loading
                              <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="number" name="loadingPercent" />
                              <ErrorMessage
                                name="loadingPercent"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Efficiency %<span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="number" name="efficiencyPercent" />
                              <ErrorMessage
                                name="efficiencyPercent"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {
                        getUserType() != "occupier" && (
                          <>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Unit Ownership <span className="astrik"></span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name="unitOwnership"
                                      onChange={(e) => {
                                        this.state.initialValues.unitOwnership = e.target.value;
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="sold" label="Sold" />
                                      <option value="owned" label="Owned" />

                                    </Field>
                                    <ErrorMessage
                                      name="unitOwnership"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Availabilty<span className="astrik"></span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name="unitAvailability"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="yes" label="Yes" />
                                      <option value="no" label="No" />

                                    </Field>
                                    <ErrorMessage
                                      name="availability"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )
                      }
                      {this.state.initialValues.unitOwnership === "sold" && (
                        <>

                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Buyer Name <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">
                                  <Field type="text" name="buyerName" />
                                  <ErrorMessage
                                    name="buyerName"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Sold Date <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">
                                  <Field type="date" name="soldDate" />
                                  <ErrorMessage
                                    name="soldDate"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Sold Amount <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">
                                  <Field type="number" name="soldAmount" />
                                  <ErrorMessage
                                    name="soldAmount"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>



                          <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                          Payment Term <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Field type="text" name="soldAmount" />
                            <ErrorMessage
                              name="soldAmount"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                        </>
                      )}

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Vacant Since
                            </label>
                            <div className="col-sm-7">
                              <Field type="date" name="vacantSince" />
                            </div>
                          </div>
                        </div>
                      </div>

                      {
                        this.state.initialValues.isCoWorking == "yes" && (
                          <>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Efficiency On Usable Area
                                  </label>
                                  <div className="col-sm-7">
                                    <Field type="number" name="efficiencyOnUsableArea" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Total no of Seats Usable
                                  </label>
                                  <div className="col-sm-7">
                                    <Field type="number" name="totalSeatUsable" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Efficiency on Billable Area(Per Seat)
                                  </label>
                                  <div className="col-sm-7">
                                    <Field type="number" name="efficiencyOnBillableArea" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Total no of Seats Billable
                                  </label>
                                  <div className="col-sm-7">
                                    <Field type="number" name="totalSeatBillable" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )
                      }



                      <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                          Owner Occupied
                          </label>
                          <div className="col-sm-7">
                            <Field type="text" name="ownerOccupied" />
                          </div>
                        </div>
                      </div>
                    </div>

                      <div className="row">
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Parking<span className="astrik"></span>
                              </label>
                              <div className="col-sm-7">
                                <Field
                                  as="select"
                                  name="parking"
                                  onChange={(e) => {
                                    this.state.initialValues.parking = e.target.value;
                                    this.setState({});
                                    handleChange(e);
                                  }}
                                >
                                  <option value="no" label="No" defaultValue />
                                  <option value="yes" label="Yes" />
                                </Field>
                                <ErrorMessage
                                  name="parking"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.state.initialValues.parking == 'yes' &&
                        <>
                          <div className="row">
                            <div className="col-lg-12 inputContainer" >
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-4">
                                      <label className="">4 wheeler parking</label>
                                    </div>
                                    <div className="col-lg-7">
                                      <Field type="number" name="totalFourWheelerParking"
                                        onChange={(e) => {
                                          handleChange(e);
                                          this.setState({ totalFourWheelerParking: parseInt(e.target.value) }, () => {
                                            //console.log(this.state.totalFourWheelerParking); // Logs the updated value in the callback
                                          });

                                          this.setState({});
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-6"></div>
                                <div className="col-2"></div>
                                <div className="col-10 mt-3">
                                  <div className="row" style={{ gap: "10px 0" }}>

                                    {Array.from({ length: this.state.totalFourWheelerParking }, (_, index) => (
                                      <div className="col-1" key={index}>
                                        <Field
                                          type="text"
                                          name={`fourWheelerParkingDetail[${index}]`}
                                          value={values.fourWheelerParkingDetail[index] ?? ''}
                                          onChange={handleChange}
                                        />
                                      </div>
                                    ))}

                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-12 inputContainer" >
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-4">
                                      <label className="">2 wheeler parking</label>
                                    </div>
                                    <div className="col-lg-7">
                                      <Field type="number" name="totalTwoWheelerParking"
                                        onChange={(e) => {
                                          handleChange(e);
                                          this.setState({ totalTwoWheelerParking: parseInt(e.target.value) }, () => {
                                            //console.log(this.state.totalTwoWheelerParking); // Logs the updated value in the callback
                                          });

                                          this.setState({});
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-6"></div>
                                <div className="col-2"></div>
                                <div className="col-10 mt-3">
                                  <div className="row" style={{ gap: "10px 0" }}>

                                    {Array.from({ length: this.state.totalTwoWheelerParking }, (_, index) => (
                                      <div className="col-1" key={index}>
                                        <Field
                                          type="text"
                                          name={`twoWheelerParkingDetail[${index}]`}
                                          value={values.twoWheelerParkingDetail[index] ?? ''}
                                          onChange={handleChange}
                                        />
                                      </div>
                                    ))}


                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-12 inputContainer" >
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-4">
                                      <label className="">Other parking</label>
                                    </div>
                                    <div className="col-lg-7">
                                      <Field type="number" name="totalOtherParking"
                                        onChange={(e) => {
                                          handleChange(e);
                                          this.setState({ totalOtherParking: parseInt(e.target.value) }, () => {
                                            //console.log(this.state.totalOtherParking); // Logs the updated value in the callback
                                          });

                                          this.setState({});
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-6"></div>
                                <div className="col-2"></div>
                                <div className="col-10 mt-3">
                                  <div className="row" style={{ gap: "10px 0" }}>

                                    {Array.from({ length: this.state.totalOtherParking }, (_, index) => (
                                      <div className="col-1" key={index}>
                                        <Field
                                          type="text"
                                          name={`otherWheelerParkingDetail[${index}]`}
                                          value={values.otherWheelerParkingDetail[index] ?? ''}
                                          onChange={handleChange}
                                        />
                                      </div>
                                    ))}

                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </>
                      }


                      <div className="tableContainer leaseLandlord">
                        {this.state.initialValues.assetCompliance.length > 0 && (
                          <table className="table tableSimple text-center">
                            <thead>
                              <tr>
                                <th>
                                  Compliance Count {this.state.compliance_count}{" "}
                                </th>
                                <th>
                                  Compliance Complete Percent(%){" "}
                                  {this.state.compliance_percent}
                                </th>
                              </tr>
                              <tr>
                                <th>Compliance Name</th>
                                <th>Compliance Answer</th>
                              </tr>
                            </thead>
                            {this.state.initialValues.assetCompliance.map(
                              (obj, i) => (
                                <tr>
                                  <td>{obj.name}</td>
                                  {obj.compliance_datatype == "date" && (
                                    <td>
                                      <Field
                                        type="date"
                                        name={"assetCompliance[" + i + "].value"}
                                      />
                                    </td>
                                  )}
                                  {obj.compliance_datatype == "checkbox" && (
                                    <td>
                                      <Field
                                        type="checkbox"
                                        name={"assetCompliance[" + i + "].value"}
                                      />
                                    </td>
                                  )}
                                </tr>
                              )
                            )}
                          </table>
                        )}
                      </div>
                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.checkDelete(e);
                                }}
                              >
                                Delete
                              </button>
                              <button
                                type="reset"
                                onClick={this.redirectAfterEdit}
                              >
                                <Link to="/masters/unit-detail">
                                  Reset
                                </Link>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Add
                              </button>
                              <button
                                type="reset"
                                onClick={this.redirectAfterEdit}
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              </div> */}
            </>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Delete the item?"
              <a className="close" onClick={this.redirectAfterSave}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Table />
      </>
    );
  }
}

export default withRouter(UnitDetailMaster);
